export enum Language {
  // RU = 'ru',
  UK = 'uk',
  EN = 'en',
  // BE = 'be',
}
